// extracted by mini-css-extract-plugin
export var collapsed = "styles-module--collapsed--DFaTH";
export var expanded = "styles-module--expanded--yKP69";
export var expandButton = "styles-module--expandButton--R8nVV";